export default "__VITE_ASSET__C0VN8c_w__"